import styled from '@emotion/styled'
import { Card } from 'react-bootstrap'
import { theme } from 'utils/theme'

export const StyledCardHeader = styled(Card.Header)`
  label: StyledCardHeader;
  display: flex;
  justify-content: space-between;
  padding-top: ${(props) => (props.nopadding ? '0px' : '18px')};
`

export const StyledPriceDiv = styled.div`
  label: StyledPriceDiv;
  font-weight: bold;
  font-size: ${() => theme.font.size.larger};
  color: ${(props) =>
    props.isGreen ? theme.colors.primary : theme.colors.textDarkblack};
  text-decoration: ${(props) =>
    props.strikethrough ? 'line-through' : 'none'};
`

export const StyledCardHeaderText = styled.div`
  label: StyledCardHeaderText;
  font-weight: bold;
  font-size: ${() => theme.font.size.medium};
  color: ${() => theme.colors.textDarkblack};
`
